export enum FEATURE_FLAGS {
    SpellingGrammarMetrics = "spelling_grammar_metrics",
    GrammarMetric = "grammar_metric",
    WritingIssuesFilter = "writing_issues_filter",
    InternalFeatureFlagToggler = "internal_feature_flag_toggler",
    Watchtower2_0 = "watchtower_2.0",
    Clickhouse = "clickhouse",
    Watchtower2_0ThemeToggler = "watchtower_2.0_theme_toggler",
    EditAIScorecards = "edit_ai_scorecards",
    EditAIScorecardPrompts = "edit_ai_scorecard_prompts",
    AIScorecardsTestPrompts = "ai_scorecards_test_prompts",
    AgentActivityMetricManipulation = "agent_activity_metric_manipulation",
    EdgetierChristmas = "edgetier-christmas",
    EditContactReasons = "edit_contact_reasons",
    AiChatShareLinks = "ai_chat_share_links",
    SpotlightToolErrorRecovery = "spotlight_tool_error_recovery",
    UpdateChecker = "update_checker",
    MultipleAgentsPerInteraction = "multiple_agents_per_interaction",
    AskSpotlightVariables = "ask_spotlight_variables",
    AskTemplates = "ask_templates",
    AskReports = "ask_reports",
    NewFilters = "new_filters",
    ExploreTagsSplitByHoverMenu = "explore_tags_split_by_hover_menu",
    AgentGroupVisibility = "agent_group_visibility",
    StandardiseDatePickerHomeScreen = "standardise_date_picker_home_screen",
    ExclusionFilters = "exclusion_filters",
}

export interface IEdgeIdentity {
    identity_uuid: string;
    identifier: string;
    dashboard_alias: string;
}

export interface IEdgeIdentityFeatureState {
    feature: {
        id: number;
        name: string;
        type: string;
    };
    enabled: boolean;
    feature_state_value: string | null;
    overridden_by: "IDENTITY" | "SEGMENT" | null;
    segment: { id: number; name: string } | null;
    multivariate_feature_state_values: Array<string>;
}
